// hasValidToken checks if the auth token of a user is still valid
export const CustomerV1_hasValidTokenLazy = () =>
  import("./customer_v1.grpc").then((m) => m.CustomerV1_hasValidToken);
CustomerV1_hasValidTokenLazy.method =
  "customer.CustomerV1/hasValidToken" as const;
